export default function loadRenderer() {
    return import("./renderer").then((module) => module.default());
}
